import { render } from "./TalkBlockComponent.vue?vue&type=template&id=13ff50dc&scoped=true"
import script from "./TalkBlockComponent.vue?vue&type=script&lang=js"
export * from "./TalkBlockComponent.vue?vue&type=script&lang=js"

import "./TalkBlockComponent.vue?vue&type=style&index=0&id=13ff50dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13ff50dc"

export default script